import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types';
import constants from '../../config/constants'

const StyledDivider = styled.hr`
  border: 0;
  border-top: ${ props => props.height }px solid ${constants.color.lightGrey2};
  display: block;
  height: 0;
  text-align: center;
  margin: .5rem 0;
  margin-right: ${ props => props.floatRight? '-15px' : '0' } !important;
  margin-left: ${ props => props.floatLeft? '-15px' : '0' } !important;

  &:before {
    color: darken(rgb(200, 200, 200), 20%);
    content: '';
    display: inline-block;
    font-size: 1.6rem;
    left: 50%;
    letter-spacing: 0;
    line-height: 1.6rem;
    text-indent: 0;
    text-rendering: geometricPrecision;
    transform: translateY(-65%);
    width: 15px;
  }
`

const Divider = (props) => {
  return (
    <StyledDivider floatRight={props.floatRight} floatLeft={props.floatLeft} height={props.height} />
  )
}

Divider.propTypes = {
  floatRight: PropTypes.bool,
  floatLeft: PropTypes.bool,
  height: PropTypes.number
};

Divider.defaultProps = {
  floatRight: false,
  floatLeft: false,
  height: 1.5
};

export default Divider
